import * as React from 'react';
export const IcGoBack10 = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M10.5 15a.5.5 0 00.5-.5v-3a.5.5 0 00-.31-.46.47.47 0 00-.54.11l-1 1a.495.495 0 10.7.7l.15-.14v1.79a.5.5 0 00.5.5zm4.5-1.5v-1a1.5 1.5 0 10-3 0v1a1.5 1.5 0 103 0zm-2 0v-1a.5.5 0 011 0v1a.5.5 0 01-1 0zM12.39 5l.32-.31A1.005 1.005 0 0012 2.976c-.266 0-.522.106-.71.294l-2 2a1 1 0 000 1.42l2 2a1.001 1.001 0 001.639-.325 1 1 0 00-.219-1.095L12.44 7A6 6 0 116 13a1 1 0 10-2 0 8 8 0 108.39-8z'
      fill='currentColor'
    />
  </svg>
);
